import React, { useEffect, useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import { IoIosClose } from "react-icons/io";
import { FiHome, FiBox, FiInfo, FiPhone, FiBookOpen } from "react-icons/fi";
import API_URL from "../config/config";

// Also reset when a visitor clicks the footer link for the current page.
const Link = (props) => <RouterLink {...props} state={{ ...props.state, scrollToTop: true }} />;

const Footer = ({ className }) => {
  const [blogsEnabled, setBlogsEnabled] = useState(false);
  useEffect(() => {
    const controller = new AbortController();
    const refresh = () => fetch(`${API_URL}/blogs/settings`, { signal: controller.signal, cache: "no-store" })
      .then(response => response.ok ? response.json() : { enabled: false })
      .then(data => setBlogsEnabled(Boolean(data.enabled)))
      .catch(() => { if (!controller.signal.aborted) setBlogsEnabled(false); });
    refresh();
    const timer = setInterval(refresh, 30000);
    window.addEventListener("focus", refresh);
    return () => { controller.abort(); clearInterval(timer); window.removeEventListener("focus", refresh); };
  }, []);
  // const [showNote, setShowNote] = useState(false);

  // const popupDismissKey = "navratriPopupDismissed2026";

  const getYear = () => {
    return new Date().getFullYear();
  };

  // useEffect(() => {
  //   const popupDismissed = localStorage.getItem(popupDismissKey);
  
  //   if (!popupDismissed) {
  //     setShowNote(true);
  //   }
  // }, []);

  // const handleCloseNote = () => {
  //   setShowNote(false);
  //   localStorage.setItem(popupDismissKey, "true");
  // };

  return (
    <section className="relative bg-gray-50">
      {/* Background Shape */}
      <img
        src="/assets/BG/bg-shape-10.png"
        className="absolute z-0 h-[40%] w-[15%] opacity-50"
        alt="Background Shape"
      />

      {/* Footer Content */}
      <section
        className={`relative w-screen Poppins flex flex-col lg:px-28 px-5 pt-12 pb-8 ${className}`}
      >
        <div className="flex flex-col lg:flex-row lg:gap-x-12 gap-y-8">
          {/* Logo and Description */}
          <div className="w-full lg:w-1/3">
            <img
              src="/assets/logo/logo.png"
              alt="Instaport Logo"
              className="h-20 w-auto mb-4"
            />

            <p className="text-gray-600 text-sm leading-relaxed">
              You can always rely on Instaport for your delivery needs, whether
              it's big or small, or even multiple goods in one go. Instaport
              Delivery is here for you.
              <br />

              <span className="text-gray-500 text-xs mt-2 block">
                By INSTAPORT DELIVERY TEAM
              </span>
            </p>
          </div>

          {/* Navigation Links */}
          <div className="lg:w-1/3 w-full grid grid-cols-2 gap-4 text-sm">
            <div className="flex flex-col">
              <h3 className="text-lg font-semibold text-gray-800 mb-4">
                Navigation
              </h3>

              <ul className="flex flex-col gap-3">
                <li>
                  <Link
                    to="/"
                    className="flex items-center gap-2 text-gray-600 hover:text-yellow-500 transition"
                  >
                    <FiHome /> Home
                  </Link>
                </li>

                <li>
                  <Link
                    to="/orders"
                    className="flex items-center gap-2 text-gray-600 hover:text-yellow-500 transition"
                  >
                    <FiBox /> Orders
                  </Link>
                </li>

                <li>
                  <Link
                    to="/about-us"
                    className="flex items-center gap-2 text-gray-600 hover:text-yellow-500 transition"
                  >
                    <FiInfo /> About Us
                  </Link>
                </li>

                <li>
                  <Link
                    to="/contact"
                    className="flex items-center gap-2 text-gray-600 hover:text-yellow-500 transition"
                  >
                    <FiPhone /> Contact Us
                  </Link>
                </li>

                {blogsEnabled && <li><Link to="/blogs" className="flex items-center gap-2 text-gray-600 hover:text-yellow-500 transition"><FiBookOpen /> Blogs</Link></li>}

                <li>
                  {/* <Link
                    to="/api"
                    className="flex items-center gap-2 text-gray-600 hover:text-yellow-500 transition"
                  >
                    API
                  </Link> */}
                </li>
              </ul>
            </div>

            <div className="flex flex-col">
              <h3 className="text-lg font-semibold text-gray-800 mb-4">
                Policies
              </h3>

              <ul className="flex flex-col gap-3">
                <li>
                  <Link
                    to="/privacy-policy"
                    className="text-gray-600 hover:text-yellow-500 transition"
                  >
                    Privacy Policy
                  </Link>
                </li>

                <li>
                  <Link
                    to="/privacy-policy-rider"
                    className="text-gray-600 hover:text-yellow-500 transition"
                  >
                    Privacy Policy Rider
                  </Link>
                </li>

                <li>
                  <Link
                    to="/terms-and-conditions/customer"
                    className="text-gray-600 hover:text-yellow-500 transition"
                  >
                    Terms and Conditions
                  </Link>
                </li>

                <li>
                  <Link
                    to="/terms-and-conditions/rider"
                    className="text-gray-600 hover:text-yellow-500 transition"
                  >
                    Terms and Conditions Rider
                  </Link>
                </li>

                <li>
                  <Link
                    to="/cancellation-and-refund"
                    className="text-gray-600 hover:text-yellow-500 transition"
                  >
                    Refund Policy
                  </Link>
                </li>

                <li>
                  <Link
                    to="/deleteaccount"
                    className="text-gray-600 hover:text-yellow-500 transition"
                  >
                    Delete Account
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          {/* App Download Links */}
          <div className="lg:w-1/3 w-full flex flex-col items-center lg:items-start">
            <h3 className="text-lg font-semibold text-gray-800 mb-4">
              Download Our App
            </h3>

            <div className="flex gap-4">
              <a
                href="https://play.google.com/store/apps/details?id=com.instaport.customer"
                target="_blank"
                rel="noopener noreferrer"
                className="transform hover:scale-105 transition"
              >
                <img
                  src="/assets/footer/playstore.png"
                  alt="Google Play Store"
                  className="h-12"
                />
              </a>

              <a
                href="https://apps.apple.com/in/app/instaport-delivery/id6751334012"
                target="_blank"
                rel="noopener noreferrer"
                className="transform hover:scale-105 transition"
              >
                <img
                  src="/assets/footer/appstore.png"
                  alt="App Store"
                  className="h-12"
                />
              </a>
            </div>

            <div className="mt-4 flex flex-col items-center lg:items-start">
              <img
                src="/assets/QR/QR.jpeg"
                alt="Instaport app QR code"
                className="h-24 w-24 object-contain"
              />

              <span className="mt-2 text-xs font-medium text-gray-500">
                Scan To download
              </span>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-8 pt-4 border-t-2 text-center text-gray-600 text-sm">
          © {getYear()} Instaport Delivery. All rights reserved.
        </div>
      </section>

      {/* Festive Popup */}
      {
  // <div
  //   className={`fixed top-0 left-0 z-[60] hidden lg:flex h-screen w-screen items-center justify-center overflow-y-auto bg-black/40 p-4 transition-opacity duration-300 ${
  //     showNote
  //       ? "opacity-100 pointer-events-auto"
  //       : "opacity-0 pointer-events-none"
  //   }`}
  // >
  //   <div className="relative my-auto w-full max-w-[1140px] overflow-hidden rounded-[28px] bg-[#fbf8ef] shadow-[0_24px_70px_rgba(15,23,42,0.24)] transition-all duration-300 max-h-[calc(100vh-2.25rem)] sm:max-h-[calc(100vh-3rem)]">
  //     <button
  //       onClick={handleCloseNote}
  //       className="absolute right-4 top-4 z-20 flex h-11 w-11 items-center justify-center rounded-full border border-[#ece2c8] bg-white text-3xl text-slate-600 shadow-[0_10px_24px_rgba(15,23,42,0.18)] transition hover:bg-white hover:text-slate-900"
  //       aria-label="Close popup"
  //     >
  //       <IoIosClose />
  //     </button>

  //     <div className="grid lg:grid-cols-[0.75fr_1fr]">
  //       {/* LEFT CONTENT */}
  //       <div className="flex flex-col bg-[#fcfaf4] px-5 pb-4 pt-3 sm:px-6 sm:pb-5 lg:px-10 lg:pb-5 lg:pt-0">
  //         <div className="pr-12 sm:pr-14 lg:pr-0">
  //           <img
  //             src="/assets/logo/logo.png"
  //             alt="Instaport Delivery"
  //             className="h-11 w-auto sm:h-13 lg:h-[3.35rem]"
  //           />
  //         </div>

  //         <div className="mt-3 inline-flex w-fit rounded-full border border-[#f0d28d] bg-[#fff2cd] px-4 py-1.5 text-[0.66rem] font-semibold uppercase tracking-[0.24em] text-[#c58a06] sm:px-5 sm:text-[0.72rem] lg:text-[0.78rem]">
  //           Navratri Special
  //         </div>

  //         <h1 className="mt-3 max-w-[590px] text-[1.72rem] font-extrabold leading-[0.9] tracking-[-0.045em] text-[#081127] sm:text-[2.05rem] lg:text-[2.55rem]">
  //           <span className="block">
  //             Celebrate the festive spirit.
  //           </span>

  //           <span className="mt-1 block text-[#1f7a37]">
  //             Celebrate Navratri
  //           </span>

  //           <span className="block text-[#f1b400]">
  //             with faster
  //           </span>

  //           <span className="block text-[#1f7a37]">
  //             city-wide delivery.
  //           </span>
  //         </h1>

  //         <p className="mt-3 max-w-[590px] text-[0.88rem] leading-[1.45] text-[#536580] sm:text-[0.92rem] lg:text-[0.96rem]">
  //           From festive gifts and pooja essentials to documents and
  //           parcels, Instaport helps you deliver across Mumbai with
  //           trusted riders and secure handling.
  //         </p>

  //         <div className="mt-4 grid gap-2 lg:grid-cols-2">
  //           <div className="rounded-[18px] border border-[#eed9ab] bg-white/88 p-3 shadow-[0_8px_24px_rgba(15,23,42,0.05)]">
  //             <h3 className="text-[0.88rem] font-bold leading-5 text-[#1f2c45]">
  //               Fast deliveries across Mumbai
  //             </h3>

  //             <p className="mt-1 text-[0.84rem] leading-[1.4] text-[#667b98]">
  //               Same-day and express delivery for festive gifts, pooja
  //               essentials, parcels and more.
  //             </p>
  //           </div>

  //           <div className="rounded-[18px] border border-[#eed9ab] bg-white/88 p-3 shadow-[0_8px_24px_rgba(15,23,42,0.05)]">
  //             <h3 className="text-[0.88rem] font-bold leading-5 text-[#1f2c45]">
  //               Better pricing, trusted service
  //             </h3>

  //             <p className="mt-1 text-[0.84rem] leading-[1.4] text-[#667b98]">
  //               Reliable delivery support for homes, shops and offices.
  //             </p>
  //           </div>
  //         </div>

  //         <div className="mt-4">
  //           <a
  //             href="https://play.google.com/store/apps/details?id=com.instaport.customer"
  //             target="_blank"
  //             rel="noopener noreferrer"
  //             className="inline-flex min-h-[54px] items-center justify-center rounded-[18px] bg-[#1e7a36] px-6 text-[0.97rem] font-bold text-white shadow-[0_20px_40px_rgba(30,122,54,0.22)] transition hover:bg-[#17632c] sm:min-w-[240px]"
  //           >
  //             Create an Order Now

  //             <span className="ml-2.5 text-[1.2rem] leading-none">
  //               →
  //             </span>
  //           </a>
  //         </div>
  //       </div>

  //       {/* RIGHT NAVRATRI IMAGE */}
  //       <div className="relative min-h-[220px] max-h-[30vh] border-t border-white/40 lg:min-h-0 lg:max-h-[calc(100vh-3rem)] lg:border-l lg:border-t-0 lg:border-l-[#ece5d6]">
  //         <img
  //           src="/assets/festive/Navratri_fes_popup.png"
  //           alt="Navratri festive artwork"
  //           className="h-full w-full object-contain object-center"
  //         />
  //       </div>
  //     </div>
  //   </div>
  // </div>
}
    </section>
  );
};

export default Footer;
